import OnBoarding from "../views/OnBoarding/OnBoarding";
import Vue from "vue";
import Router from "vue-router";

import Meta from "vue-meta";

Vue.use(Router);

Vue.use(Meta, {
  attribute: "kisme-meta",
});

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/:lang(de|en)/",
      name: "onboarding",
      component: OnBoarding,
    },
    {
      name: "fallback",
      path: "**",
      redirect: `en/`,
    },
  ],
});

router.beforeEach((to, from, next) => {
  let lang = to.params["lang"];

  if (lang == null) {
    lang = localStorage.getItem("kisme.lang");
    if (lang == null) {
      lang = "en";
    }
  }

  let changedLanguage = Vue.prototype.$locale.changeIfRequired(lang);
  if (changedLanguage) {
    localStorage.setItem("kisme.lang", lang);
  }

  next();
});

export default router;
